<ispm-clinical-trends-list [types]="groupTypes"
                           [listConfig]="listConfig"
                           (itemSelectEmitter)="onTrendItemsSelectionFilter($event, false)"
                           (onChangeTogglePanel)="changeTogglePanel($event)">
</ispm-clinical-trends-list>
<div class="trends-content-wrapper">
    <ispm-clinical-trends-filter *ngIf="filterAvailable"></ispm-clinical-trends-filter>
    <ispm-clinical-trends-graph [class.filter-available]="filterAvailable"></ispm-clinical-trends-graph>
</div>


